import $api from "@/zapi-frontend/shared/api/axios";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";

type UpdateProfileParams = {
  firstName: string;
  lastName: string;
  file?: File;
};

export function useUpdateUserProfile(
  options?: UseMutationOptions<void, AxiosError<{ message: string }>, UpdateProfileParams>
) {
  return useMutation({
    mutationKey: ["updateUserProfile"],
    mutationFn: async ({ firstName, lastName, file }: UpdateProfileParams) => {
      const formData = new FormData();
      formData.append("firstName", firstName);
      formData.append("lastName", lastName);
      if (file) formData.append("file", file);

      const response = await $api.patch("/user", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      return response.data;
    },
    ...options
  });
}
